module.exports = __webpack_public_path__ + "img/linghao-xiaochengxu.b29b53db.jpg";